export default {
  setFeatures(state, payload) {
    state.features = payload;
  },
};
